import React from 'react';
import {parsePrinterType} from '../../helpers/printer_helper';

const PrinterType = (props) => {
  const printer = props.printer;
  return (
    <>
      {parsePrinterType(printer)}
    </>
  );
};

export default PrinterType;
